export const ru = {
    'button-cancel': 'Отменить',
    'button-save': 'Сохранить',
    'button-tree': 'Разделы',
    canel: 'Отменить',
    'cluster-navigation': 'Структура раздела',
    'create-subpage': 'Создать подстраницу',
    'empty-description': 'Вы можете быть первым',
    'empty-title': 'В разделе нет страниц',
    'error-become-not-accessible': 'После переноса вы потеряете доступ к странице',
    'error-cluster-not-exists': 'Страница, которую вы хотите перенести, не существует.',
    'error-cluster-permissions': 'У вас нет доступа к подстраницам',
    'error-destination-reserved': 'Невозможно перенести страницу, новый адрес зарезервирован.',
    'error-general': 'Не удалось выполнить перенос. Обновите страницу и попробуйте ещё раз.',
    'error-into-self': 'Невозможно перенести страницу, она уже находится по указанному адресу.',
    'error-limit-exceeded': 'Нельзя одновременно делать совершать больше 100 переносов',
    'error-long-name': 'Новые адреса страниц будут слишком длинными',
    'error-next-to-not-set': 'Нельзя переместить страницу в тот же кластер',
    'error-override': 'Невозможно перенести страницу, новый адрес занят другой страницей.',
    'error-source-reserved': 'Невозможно перенести системную страницу.',
    expand: 'Развернуть',
    'get-tree-error': 'Не удалось загрузить данные',
    'header-editing': 'Изменение структуры',
    'header-moving': 'Загрузка...',
    'leave-unsaved-message': 'Вы действительно хотите покинуть страницу? Изменения в структуре раздела будут потеряны.',
    'load-more': 'Показать ещё',
    'move-success': 'Страница перенесена',
    moving: 'Перемещение',
    'pages-move-message': 'Обновляем структуру раздела, это может занять от мгновения до нескольких минут...',
    'root-cluster-navigation': 'Структура Вики'
};
